import {useCallback} from 'react';

import {ApiApplicationCredentials} from '../../models/api/applicationCredentialsModel';
import {ServerModel} from '../../models/api/serverModel';
import {fetchApiAsync} from '../../services/http/http';
import {useSettingsInvalidateQueries, useSettingsQuery} from '../helpers/useSettingsQuery';

/*
 * Consts.
 */

const applicationCredentialsQueryKeyFactory = {
  all: ['applications'],
  id: (url?: string) => ['applicationCredentials', {url}],
};

/*
 * Fetchers.
 */

export function useFetchApplicationCredentials(server: ServerModel | undefined) {
  const {data, asyncStatus} = useSettingsQuery(
    applicationCredentialsQueryKeyFactory.id(server?.installationUrl),
    async ({cancelToken}) =>
      server?.installationUrl
        ? fetchApiAsync(ApiApplicationCredentials, `${server?.installationUrl}/credentials`, {cancelToken})
        : undefined,
  );

  return {applicationCredentials: data, status: asyncStatus};
}

export function useInvalidateApplicationCredentials() {
  const invalidate = useSettingsInvalidateQueries();

  return useCallback(
    (server: ServerModel | undefined) => {
      invalidate(applicationCredentialsQueryKeyFactory.id(server?.installationUrl), {shouldUncache: true});
    },
    [invalidate],
  );
}
